import './styles/Carousel.scss';

import { ReactNode } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import Logo from '../Logo';

interface Props {
  images: string[];
  path?: string;
  imageSize?: 'tiny' | 'small' | 'medium' | 'large';
  itemsToShow?: number;
  children?: ReactNode[];
  className?: string;
}

export default function CustomCarousel(props: Props) {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 768 },
      items: props.itemsToShow || 1
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: props.itemsToShow || 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: props.itemsToShow || 1
    }
  };
  return (
    <Carousel
      responsive={responsive}
      swipeable={false}
      draggable={false}
      ssr={false}
      infinite={false}
      partialVisible={true}
      containerClass="carousel"
      sliderClass="carousel-track"
      itemClass="carousel-item"
      deviceType={'desktop'}
    >
      {!!props.children?.length
        ? props.children
        : props.images.map(i => {
            return <Logo key={i} path={props.path} src={i} />;
          })}
    </Carousel>
  );
}
